import Auth from '../auth/Auth';
import SystemEmailTemplate from "../models/SystemEmailTemplate";
import { WebClient } from './WebClient'

class ApiSystemEmailTemplates extends WebClient {
    async getEmailTemplates(): Promise<SystemEmailTemplate[]> {
        const url = `/systememailtemplates`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async saveEmailTemplate(emailTemplate: SystemEmailTemplate): Promise<SystemEmailTemplate> {
        const url = `/systememailtemplates`;

        return this.post(url, emailTemplate, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return;
        }).catch(() => { return; });
    }
}

export default new ApiSystemEmailTemplates();
